module.exports = __webpack_public_path__ + "assets/img/bottomBg.e4ebb91c.png";